module.exports = __webpack_public_path__ + "img/mask20small.439f4eb3.png";